import { Link } from "react-router-dom";
import { categoryMetas } from "@/mocks/articles";
import { getArticlesByCategory } from "@/utils/articles";

const tints = [
  { bg: "bg-primary-50", icon: "bg-primary-500 text-background-50", ring: "group-hover:border-primary-300" },
  { bg: "bg-accent-50", icon: "bg-accent-500 text-primary-950", ring: "group-hover:border-accent-300" },
  { bg: "bg-secondary-50", icon: "bg-secondary-500 text-background-50", ring: "group-hover:border-secondary-300" },
];

export default function CategoryEntries() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8 py-14 md:py-20">
      <div className="text-center mb-10 md:mb-14">
        <p className="text-xs tracking-[0.3em] text-secondary-600 mb-3">EXPLORE</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          按栏目深入阅读
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {categoryMetas.map((cat, i) => {
          const tint = tints[i % tints.length];
          const count = getArticlesByCategory(cat.id).length;
          return (
            <Link
              key={cat.id}
              to={cat.path}
              className={`group ${tint.bg} border border-background-200 ${tint.ring} rounded-lg p-6 md:p-8 transition-colors`}
            >
              <div className={`w-14 h-14 rounded-md ${tint.icon} flex items-center justify-center mb-6`}>
                <i className={`${cat.icon} text-2xl`} />
              </div>
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs tracking-widest text-foreground-400 mb-4 uppercase">
                {cat.enName}
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                {cat.description}
              </p>
              <span className="inline-flex items-center gap-2 text-sm font-medium text-secondary-700">
                进入栏目 · {count} 篇
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}